import React, { ReactElement } from 'react';

import { TGlobalColors } from '@pb/styles';
import { Spinner } from '@pb/shared/ui/atoms/spinner';
import { Heading } from '@pb/shared/ui/atoms/heading';
import {
    StyledLoadingWrapper,
    StyledSpinnerWrapper,
} from './loading-spinner.styled';

type TLoadingSpinnerProperties = {
    text?: string;
    background?: TGlobalColors;
};

export type TStyledLoadingSpinner = {
    color: TGlobalColors;
};

export function LoadingSpinner({
    background,
    text,
}: TLoadingSpinnerProperties): ReactElement {
    return (
        <StyledLoadingWrapper color={background ? background : 'grey1'}>
            <StyledSpinnerWrapper>
                <Spinner />
            </StyledSpinnerWrapper>
            <Heading size="xxsmall">{text ? text : 'Loading...'}</Heading>
        </StyledLoadingWrapper>
    );
}
